<template>
  <el-dialog title="编辑临时排班" :visible.sync="dialogVisible" :close-on-click-modal="false"
             :close-on-press-escape="false" @close="dialogFormVisible" width="600px">
    <el-form :model="form" ref="formRef" label-width="120px">
      <!-- 调整日期 -->
      <el-form-item label="上班日期" prop="schedule_date" :rules="[{ required: true, message: '请选择上班日期' }]">
        <el-date-picker v-model="form.schedule_date" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
      </el-form-item>

      <!-- 工作时间 -->
      <el-form-item label="工作时间" prop="work_time_range" :rules="[{ required: true, message: '请设置工作时间' }]">
        <el-time-picker is-range v-model="form.work_time_range" range-separator="至" start-placeholder="上班时间"
                        end-placeholder="下班时间" value-format="HH:mm:ss">
        </el-time-picker>
      </el-form-item>

      <!-- 休息时间 -->
      <el-form-item label="休息时间" prop="break_time_range">
        <el-time-picker is-range v-model="form.break_time_range" range-separator="至" start-placeholder="休息开始"
                        end-placeholder="休息结束" value-format="HH:mm:ss" >
        </el-time-picker>
      </el-form-item>

      <!-- 备注 -->
      <el-form-item label="备注" prop="note">
        <el-input type="textarea" v-model="form.note" placeholder="例如：支援A店活动"></el-input>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="submitClick" :loading="loading">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import ScheduleOverrideApi from '@/api/technician/scheduleOverride.js';

export default {
  name: 'ScheduleOverrideEdit',
  props: ['open_edit', 'schedule_data'],
  data() {
    return {
      loading: false,
      dialogVisible: false,
      form: {
        id: 0,
        technician_id: 0,
        schedule_date: '',
        start_time: null,
        end_time: null,
        break_start_time: null,
        break_end_time: null,
        note: '',
        // 辅助字段
        work_time_range: null,
        break_time_range: null
      }
    };
  },
  created() {
    this.dialogVisible = this.open_edit;
    this.initForm();
  },
  methods: {
    /**
     * 初始化表单数据
     */
    initForm() {
      if (this.schedule_data) {
        this.form.id = this.schedule_data.id;
        this.form.technician_id = this.schedule_data.technician_id;
        this.form.schedule_date = this.schedule_data.schedule_date;
        this.form.start_time = this.schedule_data.start_time;
        this.form.end_time = this.schedule_data.end_time;
        this.form.break_start_time = this.schedule_data.break_start_time;
        this.form.break_end_time = this.schedule_data.break_end_time;
        this.form.note = this.schedule_data.note || '';
        
        // 设置工作时间范围
        if (this.schedule_data.start_time && this.schedule_data.end_time) {
          this.form.work_time_range = [this.schedule_data.start_time, this.schedule_data.end_time];
        }
        
        // 设置休息时间范围
        if (this.schedule_data.break_start_time && this.schedule_data.break_end_time) {
          this.form.break_time_range = [this.schedule_data.break_start_time, this.schedule_data.break_end_time];
        }
      }
    },
    /**
     * 提交表单
     */
    submitClick() {
      let self = this;
      self.$refs.formRef.validate(valid => {
        if (valid) {
          self.loading = true;

          // 从辅助字段赋值给真实字段
          if (self.form.work_time_range && self.form.work_time_range.length >= 2) {
            self.form.start_time = self.form.work_time_range[0];
            self.form.end_time = self.form.work_time_range[1];
          } else {
            self.form.start_time = null;
            self.form.end_time = null;
          }

          if (self.form.break_time_range && self.form.break_time_range.length >= 2) {
            self.form.break_start_time = self.form.break_time_range[0];
            self.form.break_end_time = self.form.break_time_range[1];
          } else {
            self.form.break_start_time = null;
            self.form.break_end_time = null;
          }

          // 准备提交的数据，移除辅助字段
          const { work_time_range, break_time_range, ...params } = self.form;

          ScheduleOverrideApi.edit(params, true)
            .then((res) => {
              self.loading = false;
              if (res.code === 1) {
                self.$message.success('修改成功');
                self.dialogFormVisible(true);
              }
            })
            .catch(() => {
              self.loading = false;
            });
        }
      });
    },
    /**
     * 关闭弹窗
     */
    dialogFormVisible(isSuccess) {
      this.$emit('closeDialog', { type: isSuccess ? 'success' : 'cancel' });
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/technician/scheduleoverride/Edit.vue